// extracted by mini-css-extract-plugin
export var container = "PublisherDeveloperSubForm-module__container___f5Z-G";
export var dynamicContainer = "PublisherDeveloperSubForm-module__dynamicContainer___BQ8W0";
export var large = "1084px";
export var medium = "860px";
export var option = "PublisherDeveloperSubForm-module__option___jWHZA";
export var optionMargin = "PublisherDeveloperSubForm-module__optionMargin___0QJHh";
export var optionsGroups = "PublisherDeveloperSubForm-module__optionsGroups___B4lSK";
export var small = "540px";